<template>
  <div class="record-box">
    <div class="title">
      <h1>佣金记录</h1>
      <div class="price-msg">
        <p>应收：{{ answerCollection }}元</p>
        <p>已收：{{ alreadyCollection}}元</p>
        <p>未收：{{ answerCollection - alreadyCollection }}元</p>
      </div>
      <div class="btns">
        <h2
          @click="commissionClick('新增')"
          v-hasPermi="['system:commissionRecord:add']"
          v-if="contractsDetails.isArchive !== 'Y'"
        >
          <a-icon style="margin-right: 10px" v-if="contractsDetails.isArchive !== 'Y'" type="edit" />新增
        </h2>
        <h2
          v-if="contractsDetails.auditStatus === '3'"
          v-hasPermi="['system:commissionRecord:edit']"
          @click="isEditCommission = !isEditCommission"
        >
          编辑
        </h2>
        <h2
          v-if="contractsDetails.auditStatus !== '3' && contractsDetails.signId === userId"
          v-hasPermi="['system:commissionRecord:edit']"
          @click="isEditCommission = !isEditCommission"
        >
          编辑
        </h2>
        <h2 v-if="contractsDetails.isArchive === 'Y' && $getters.userInfo.admin" @click="commissionClick('冲红')">
          冲红
        </h2>
        <!--  -->
      </div>
    </div>
    <div class="msg-box">
      <div>
        <h3>房源方</h3>
        <p>{{ commission.house }}</p>
      </div>
      <div>
        <h3>客源方</h3>
        <p>{{ commission.customer }}</p>
      </div>
      <div>
        <h3>信息费</h3>
        <p>{{ commission.informationPrice && commission.informationPrice.toFixed(2) }}</p>
      </div>
      <div>
        <h3>结单业绩</h3>
        <p>{{ commission.sum.toFixed(2) }}</p>
      </div>
    </div>
    <div class="data-box">
      <div class="data-item" v-for="item in commissionList" :key="item.id">
        <div class="item-left">
          <h1 v-if="item.commissionType === '1'">房源方</h1>
          <h1 style="background: #7dd9a5" v-if="item.commissionType === '2'">客源方</h1>
          <h1 style="font-size: 12px; background: #8a94f8" v-if="item.commissionType === '3'">房源信息费</h1>
          <h1 style="font-size: 12px" v-if="item.commissionType === '4'">客源信息费</h1>
          <h1 v-if="item.commissionType === '5'">其他</h1>
          <h1 style="font-size: 12px; background: red" v-if="item.commissionType === '6'">冲红</h1>
          <p>{{ item.commissionFee }}</p>
          <div>
            <p v-if="item.commissionType === '1' || item.commissionType === '2'" class="detailed-price">
              已收：{{ item.realIncome || 0 }}元
            </p>
            <p
              v-if="item.commissionType === '1' || item.commissionType === '2'"
              class="detailed-price"
              @click="seeCollectionPrice(item)"
            >
              查看明细
            </p>
          </div>
        </div>
        <div class="item-right">
          <p>{{ item.createTime }}</p>
          <div>
            <div v-show="isEditCommission && item.commissionType !== '6'">
              <a-button shape="circle" @click="commissionClick(item)">
                <a-icon type="edit" theme="filled" />
              </a-button>
              <a-button
                v-if="item.commissionType === '1' || item.commissionType === '2'"
                shape="circle"
                @click="commissionDetailClick(item)"
              >
                <a-icon type="plus" />
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: [Number, String],
      default: 0,
    },
    answerCollection: {
      type: [Number, String],
      default: 0,
    },
    blushCollection:{
      type: [Number, String],
      default: 0,
    },
    alreadyCollection: {
      type: [Number, String],
      default: 0,
    },
    contractsDetails: {
      type: Object,
      default: () => ({}),
    },
    commission: {
      type: Object,
      default: () => ({}),
    },
    commissionList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    contractsDetails: {
      handler(val) {},
      deep: true,
      immediate: true,
    },
    commission: {
      handler(val) {},
      deep: true,
      immediate: true,
    },
    commissionList: {
      handler(val) {},
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isEditCommission: false,
    }
  },
  methods: {
    commissionClick(item) {
      this.$emit('commissionClick', item)
    },
    seeCollectionPrice(item) {
      this.$emit('seeCollectionPrice', item)
    },
    commissionDetailClick(item) {
      this.$emit('commissionDetailClick', item)
    },
  },
}
</script>

<style lang="less">
.record-box {
  .title {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price-msg {
      display: flex;
      padding-top: 6px;
      width: 60%;
      justify-content: space-between;
      p {
        padding: 0 20px 0 0;
      }
      p:nth-child(1) {
        color: #c0a5f8;
      }
      p:nth-child(2) {
        color: #7dd9a5;
      }
      p:nth-child(3) {
        color: #e64177;
      }
    }
    h1 {
      color: var(--ThemeColor);
      font-size: 16px;
      font-weight: 700;
    }
  }
  .btns {
    display: flex;
    i {
      color: var(--ThemeColor);
      font-size: 16px;
      margin-top: 2px;
    }
    h2 {
      font-weight: 700;
      font-size: 14px;
      color: var(--ThemeColor);
      padding: 0 10px;
      cursor: pointer;
    }
  }
  .msg-box {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(243, 240, 240);
    h3 {
      color: #222222;
      font-weight: 600;
      font-size: 14px;
    }
    p {
      font-size: 14px;
      color: #666666;
      font-weight: 700;
    }
    div {
      margin-right: 20px;
    }
  }
  .data-box {
    .data-item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      .item-left {
        display: flex;
        align-items: center;
        .detailed-price {
          color: #7dd9a5;
        }
        .detailed-price:nth-child(2) {
          cursor: pointer;
        }
        h1 {
          width: 60px;
          height: 60px;
          background-color: var(--ThemeColor);
          color: #fff;
          border-radius: 50%;
          text-align: center;
          line-height: 55px;
        }
        p {
          color: #222222;
          font-weight: 700;
          font-size: 14px;
          margin-left: 20px;
        }
      }
      .item-right {
        display: flex;
        align-items: center;
        > p {
          font-weight: 600;
        }
        > div {
          margin-left: 30px;
          height: 80px;
          width: 46px;
          div {
            display: flex;
            flex-direction: column;

            button {
              margin: 6px 10px;
              background-color: var(--ThemeColor);
              color: #fff;
            }
            button:nth-child(2) {
              background-color: #7dd9a5;
            }
          }
        }
      }
    }
  }
}
</style>
